<section class="not-found-page" aria-labelledby="not-found-title">
  <div class="not-found-page__panel">
    <p class="not-found-page__eyebrow">Advertencia</p>
    <p class="not-found-page__code">404</p>

    <h1 id="not-found-title" class="not-found-page__title">
      Página no encontrada
    </h1>

    <p class="not-found-page__description">
      La ruta que intentaste abrir no existe o ya no está disponible. Puedes
      volver a la pantalla anterior o regresar al inicio para seguir navegando.
    </p>

    <div class="not-found-page__actions">
      <button type="button" class="not-found-page__action" (click)="goBack()">
        Volver
      </button>

      <a
        routerLink="/"
        class="not-found-page__action not-found-page__action--primary"
      >
        Ir al inicio
      </a>
    </div>
  </div>
</section>
